import { TaxNumberTypeCode } from '@/types/api/tax-info';

export const MAX_FOREIGN_TAX_RESIDENCIES = 3;
export const FOREIGN_TAX_OTHER_NUMBER_TYPE_MAX_LENGTH = 10;

export const FOREIGN_TAX_NUMBER_TYPE_OPTION_CODES = [
  TaxNumberTypeCode.BIR,
  TaxNumberTypeCode.TIN,
  TaxNumberTypeCode.TPN,
  TaxNumberTypeCode.CRIB,
  TaxNumberTypeCode.FIN,
] as const;

export const FOREIGN_TAX_NUMBER_TYPE_CODES = [
  ...FOREIGN_TAX_NUMBER_TYPE_OPTION_CODES,
  TaxNumberTypeCode.OTHER,
] as const;
